import { SupportedCountry } from '@/helpers/phone'
import { ClientCountry } from '@/types/client'

export * from './enums/ActionType'
export * from './enums/LinkType'
export * from './enums/TileCategory'
export * from './enums/TileColour'
export * from './enums/TileIcon'
export * from './enums/TileTitles'
export * from './enums/TileType'

export * from './base/BaseChannelAction'
export * from './base/ChannelItem'

export * from './content/AudioContentItem'
export * from './content/CarouselContentItem'
export * from './content/CastContentItem'
export * from './content/InfoSection'
export * from './content/TextContentItem'
export * from './content/TranscodedMedia'
export * from './content/TriggerContentItem'

export * from './composite/Action'
export * from './composite/TileItem'

export * from './channel/Channel'
export * from './channel/Channels'

export * from './subscription'
export * from './user'

export type Location = {
  id: string
  name: string
}

export type Currency = {
  name: string
  symbol: string
}

export type Seat = {
  seat_id: string
  location: string
  name: string
  row: string
  number: string
  band_uid: string
  tier: number
  upgrade_price: number
  original_price: number
  discount: number
  saved_price: number
  number_tickets: number
  position?: number
}

export type PriceBand = {
  uid: string
  active_discount: number
  discount_price?: number
  original_price: number
  upgrade_values: {
    upgrade_price: number
    original_price: number
    saved_price: number
    number_tickets: number
    discount_percentage: number
    unit_original_price: number
    unit_upgrade_price: number
  }
}

export type CountryCode = {
  code: string
  acronym: SupportedCountry
  digits: string
}

export enum TicketStates {
  UPGRADE_NOW = 'Upgrade Now',
  UPGRADED = 'Upgraded',
  UPGRADE_TO_BE_AVAILABLE = 'Upgrades Available 1-8pm',
  VIEW_TICKET = 'View Ticket',
}

export type State = {
  code: number
  msg: string
}

export type ShowData = {
  title: string
  dateFrom: Date
  dateTo: Date
  imageUrl?: string
}

export type PricePoint = {
  percentage: number
  seatType: string
}

export type BasketSeat = {
  seat_name: string
  plan_name: string
}

export type BasketType = {
  UPGRADE: 'upgrade'
  SWAP: 'swap'
}

export type Payable = {
  uid: string
  status: string
  gross_price: string
  total_price: string
  order_fee: string
  payable_type: string
  unit_price?: string
  number_tickets?: number
  currency: string
  country?: ClientCountry | null
  terms_of_use?: string | null
}

export type Basket = {
  seats: BasketSeat[]
  payable: Payable
  uid: string
  upgrade_uid?: string
  swap_uid?: string
  expires_utc: Date
  swap_fee?: string
  price_difference?: string
}

export enum SectionNames {
  HOME = 'HOME',
  SEARCH = 'SEARCH',
  TICKETS = 'TICKETS',
  ACCOUNT = 'ACCOUNT',
}

export type Section = {
  index: number
  name: SectionNames
}

export const sectionMap: Record<number, SectionNames> = {
  0: SectionNames.HOME,
  1: SectionNames.SEARCH,
  2: SectionNames.TICKETS,
  3: SectionNames.ACCOUNT,
}

export interface SeatMapTestProps {
  selectedSeats: Seat[]
  setSelectedSeats: (seats: Seat[]) => void
  priceBands: PriceBand[]
  mapSeats: Seat[]
}
